<div class="h-100 d-flex text-center flex-column justify-content-center">
  <div class="container-xxl">
    <i-feather tooltip="Ошибка загрузки" name="alert-triangle" class="text-danger icon-xxl mb-2"></i-feather>
    <small class="text-muted d-block mt-2">{{ loadErrorText }}</small>
    <h6 class="m-1">
      <a *ngIf="showReport" (click)="senderService.openHelpChatInTelegram()" rel="noopener" target="_blank" class="pointer">Сообщить об ошибке</a>
    </h6>
    <ng-content></ng-content>
    <i-feather
      *ngIf="reload"
      (click)="onReload.emit(true)"
      tooltip="Попытка обновить"
      name="refresh-cw"
      class="text-success icon-lg pointer"
    ></i-feather>

  </div>
</div>
